// client/src/hooks/useCategories.js

import { useState, useCallback } from 'react';
import categoryService from '../services/categoryService';

const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState({
    categories: false,
    save: false,
    categorize: false
  });
  const [error, setError] = useState('');

  const fetchCategories = useCallback(async () => {
    setLoading((prev) => ({ ...prev, categories: true }));
    setError('');
    try {
      const data = await categoryService.getCategories();
      setCategories(data);
      return data;
    } catch (err) {
      setError(err.message || 'Impossible de charger les catégories.');
      throw err;
    } finally {
      setLoading((prev) => ({ ...prev, categories: false }));
    }
  }, []);

  const createCategory = useCallback(async (data) => {
    setLoading((prev) => ({ ...prev, save: true }));
    setError('');
    try {
      return await categoryService.createCategory(data);
    } catch (err) {
      setError(err.message || 'Erreur lors de la création.');
      throw err;
    } finally {
      setLoading((prev) => ({ ...prev, save: false }));
    }
  }, []);

  const updateCategory = useCallback(async (id, data) => {
    setLoading((prev) => ({ ...prev, save: true }));
    setError('');
    try {
      return await categoryService.updateCategory(id, data);
    } catch (err) {
      setError(err.message || 'Erreur lors de la mise à jour.');
      throw err;
    } finally {
      setLoading((prev) => ({ ...prev, save: false }));
    }
  }, []);

  const deleteCategory = useCallback(async (id) => {
    setError('');
    try {
      return await categoryService.deleteCategory(id);
    } catch (err) {
      setError(err.message || 'Erreur lors de la suppression.');
      throw err;
    }
  }, []);

  const categorize = useCallback(async (accountId) => {
    setLoading((prev) => ({ ...prev, categorize: true }));
    setError('');
    try {
      return await categoryService.categorize(accountId);
    } catch (err) {
      setError(err.message || 'Erreur lors de la catégorisation.');
      throw err;
    } finally {
      setLoading((prev) => ({ ...prev, categorize: false }));
    }
  }, []);

  const setTransactionCategory = useCallback(async (transactionId, categoryId, applyToSimilar) => {
    setError('');
    try {
      return await categoryService.setTransactionCategory(
        transactionId,
        categoryId,
        applyToSimilar
      );
    } catch (err) {
      setError(err.message || 'Erreur lors du reclassement.');
      throw err;
    }
  }, []);

  return {
    categories,
    loading,
    error,
    setError,
    fetchCategories,
    createCategory,
    updateCategory,
    deleteCategory,
    categorize,
    setTransactionCategory
  };
};

export default useCategories;
